import { create } from 'zustand';

export const useConfigStore = create((set) => ({
	// sound
	sound: true,
	setSound: (value) => set({ sound: value }),

	// modal
	isModalOpen: false,
	modalComponent: null,
	modalProps: null,

	openModal: (component, props = null) =>
		set({
			isModalOpen: true,
			modalComponent: component,
			modalProps: props,
		}),

	closeModal: () =>
		set({
			isModalOpen: false,
			modalComponent: null,
			modalProps: null,
		}),
}));
